import { useContext } from "react";
import { userPermissionContext } from '../context/UserPagePermission';

// 1 when the user's role has the page link, otherwise 0 (also while the links are loading).
function GetPagePermission(value) {
	const { pagesLink } = useContext(userPermissionContext);

	return pagesLink && pagesLink.some(link => link.pagesLink === value) ? 1 : 0;
}
export default GetPagePermission;
